<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div
    v-if="
      entityCustomFields != null &&
      entityCustomFields.length > 0 &&
      organizationCustomFields != null &&
      organizationCustomFields.length > 0
    ">
    <div class="row">
      <div class="col-12">
        <div class="pane-header">
          <span class="icon"><icon-colored-custom-field /></span>
          <span class="text">{{ title ? title : capitalize($t('names.organizationCustomField', { n: 2 })) }}</span>
        </div>
      </div>
      <div class="col-12">
        <div class="pane-content pad-top">
          <div class="row">
            <div
              v-for="field in entityCustomFields"
              :key="field.key"
              class="col-12 col-sm-6">
              <h4>
                {{
                  organizationCustomFields.find((x) => x.key === field.key) != null
                    ? organizationCustomFields.find((x) => x.key === field.key).name
                    : field.key
                }}
              </h4>
              <span
                class="text-muted entity-custom-field-value"
                v-text="field.value || DASH" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import { capitalize } from 'vue';

  import IconColoredCustomField from '@/common/icons/colored/CustomField';
  import { DASH } from '@/globals';

  export default {
    components: {
      IconColoredCustomField,
    },
    props: {
      organizationCustomFields: {
        type: Array,
      },
      entityCustomFields: {
        type: Array,
      },
      title: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        isExpanded: true,
        DASH,
      };
    },
    methods: {
      capitalize,
    },
  };
</script>
